






































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import SelectMultiSearch from "./select-multi-search.vue";
import {
  GetTopicsOfTemplate,
  GetHospitalsOfLcksOrMzy,
  GetTemplatesOfGroup,
  GetZyyxTemplates,
  GetZyyxTopicsOfTemplate
} from "@/request/projects";
import { GetHospitals as ZwbFetchHospitals } from "@/request/hdr";
import ZwbPrimarySearch from "../../../../hdr/views/patient-list/sizhen-patients/primary-filter.vue";
@Component({
  components: {
    ZwbPrimarySearch,
    SelectMultiSearch
  }
})
export default class ProjectImportPatientFilter extends Vue {
  @Prop()
  private center: any;
  @Prop()
  private projectId: any;
  @Prop()
  private groupId: any;
  private hospital: any = {
    hospital_id: ""
  };
  private hospitals: any[] = [];
  @Prop()
  private filters: any;
  private searchedTemplates: any[] = [];
  // 高级搜索
  private ifShowPrimarySearch: boolean = false;
  private ifShowZwbPrimarySearch: boolean = false;
  @Watch("center.id", { immediate: true })
  private centerIdChange(id) {
    this.fetchHospitals();
  }
  /**
   * @description 获得所有可选的机构列表
   */
  private fetchHospitals() {
    switch (this.center.id) {
      case "治未病数据中心":
      case "中医影像数据中心":
        ZwbFetchHospitals(this).then((data: any) => {
          this.hospitals = data;
        });
        break;
      case "临床科室数据中心":
      case "名中医传承数据中心":
        const params: any = {
          params: {
            project_id: this.$route.query.src_project_id
          }
        };
        GetHospitalsOfLcksOrMzy(this, params).then((data: any) => {
          this.hospitals = data;
        });
        break;
    }
  }
  /**
   * @description 治未病高级筛选
   */
  private zwbPrimaryFilterChange(filters) {
    this.ifShowZwbPrimarySearch = false;
    this.$emit("primarySearch", filters);
  }
  // 其他高级筛选
  /**
   * @description 临床科室或名中医打开高级筛选
   */
  private openPrimarySearchLcksMyz() {
    this.ifShowPrimarySearch = true;
    this.fetchTemplates();
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["研究指标"].push({ result: {}, selected: {} });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    if (this.center.id === "中医影像数据中心") {
      GetZyyxTemplates(this).then((data: any) => {
        this.searchedTemplates = data;
      });
    } else {
      GetTemplatesOfGroup(this, this.projectId, this.groupId).then(
        (data: any) => {
          this.searchedTemplates = data;
        }
      );
    }
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    if (this.center.id === "中医影像数据中心") {
      GetZyyxTopicsOfTemplate(this, l.template_id).then((data: any) => {
        l.items = data;
        this.$forceUpdate();
      });
    } else {
      GetTopicsOfTemplate(this, l.template_id).then((data: any) => {
        l.items = data;
        this.$forceUpdate();
      });
    }
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["研究指标"].splice(index, 1);
  }
  /**
   * @description 重置高级搜索
   */
  private resetPrimarySearch() {
    this.filters.timeWay = "";
    this.filters.time = [];
    this.filters["条件"] = "";
    this.filters["研究指标"] = [];
    this.search();
  }
  /**
   * @description 取消高级筛选
   */
  private cancelPrimarySearch() {
    this.resetPrimarySearch();
  }
  /**
   * @description 确定高级筛选
   */
  private confirmPrimarySearch() {
    this.ifShowPrimarySearch = false;
    this.$emit("primarySearch", this.filters);
  }
  /**
   * @description 重新搜索
   */
  private search() {
    this.$emit("search");
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    // console.log(localStorage.getItem("token"));
  }
}
